import { useRedux } from "hooks";
import { Link } from "react-router-dom";
import { createSelector } from "reselect";
import classnames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { Utils } from "helpers/utils";
import { delGroupFromUser, setUserGroups } from "../redux/profile2/p2_reducer";
import { applyUserToGroupAsync } from "../api/chats";
import { getChatRoomLists, changeSelectedChat } from "../redux/actions";
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Loader from "./Loader";
import { UserTypes } from "api";
import { distance } from "framer-motion";
import UserAvatar from "./UserAvatar";
import { setActivePostId2 } from "../redux/workplace/wpActions";
import { TABS, WpModes } from "../constants";

const UserGroups = () => {
    const colors = [
        "bg-primary",
        "bg-danger",
        "bg-info",
        "bg-warning",
        "bg-secondary",
        "bg-pink",
        "bg-purple",
    ];
    const [color] = useState(Math.floor(Math.random() * colors.length));
    const { dispatch, useAppSelector } = useRedux();
    const storeData = createSelector(
        (state: any) => state.Profile2,
        (state: any) => state.Chats,
        (p2, ct) => ({
            groups: p2.groups,
            curUserType: p2.userType,
            curUserId: p2.userId,
            selectedChat: ct.selectedChat,
        })
    );
    const { groups, curUserType, curUserId, selectedChat } = useAppSelector(storeData);
    // console.log('UserGroup.groups:', groups);

    const onRemoveGroup = (gruopId: number, userId: number) => {
        if (Utils.IsViewAsAlert()) return false;
        
        Utils.SweetConfirm('ท่านต้องการ ออกจากกลุ่มที่เลือก ใช่หรือไม่')
            .then((result) => {
                if (result.isConfirmed) {
                    dispatch(delGroupFromUser(gruopId, userId));
                    if (gruopId == selectedChat) {
                        //console.log('onRemoveGroup.selectedChat = null');
                        dispatch(changeSelectedChat(null));
                        dispatch(setActivePostId2(WpModes.Workplace, null, null, null, null, null, "UserGroup remove group"));
                    }
                    // try { -> move to saga
                    //     dispatch(getChatRoomLists());
                    // } catch (e) {
                    //     alert((e as Error).message);
                    // }
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const onAddGroup = () => {
        try {
            SetIsOpen(true);

        } catch (e) {
            alert((e as Error).message);
        }
    }

    const logo = (item: any) => {
        const color2 = Math.floor(Math.random() * colors.length);
        return (
            item.profileImage ? (
                <div
                    className={classnames(
                        "chat-user-img",
                        "align-self-center",
                        "me-2",
                        "ms-0"
                    )}
                >
                    <img
                        src={item.profileImage}
                        className="rounded-circle avatar-xs"
                        alt=""
                    />
                </div>
            ) : (
                <span
                    className={classnames(
                        "avatar-title",
                        "rounded-circle",
                        "text-uppercase",
                        "text-white",
                        colors[color2]
                    )}
                >
                    {Utils.GetShortNameIcon(item.groupName, '')}
                </span>
            )
        );
    }
    const onClose = () => {
        SetIsOpen(false);
    }
    const [isOpen, SetIsOpen] = useState<boolean>(false);
    // const [errMessage, SetErrMessage] = useState<string>("");
    const [errClass, SetErrClass] = useState<string>("danger");
    const txtCodeRef = useRef<any>(null); // Correctly typing the ref
    const txtError = useRef<any>(null);

    const onKeyDown = (event: any) => {
        if (event.key === "Enter") {
            onConfirmCode(event);
        }
    }

    const fnSetMsg = (msg: string) => {
        if (txtError.current) {
            txtError.current.style.display = msg ? "" : "none";
            txtError.current.innerText = msg;
        }
    }

    const onConfirmCode = (event: any) => {
        if (Utils.IsViewAsAlert()) return false;

        event.preventDefault();
        try {
            if (txtCodeRef && txtCodeRef.current) {
                // console.log(txtError);
                const code = txtCodeRef.current.value;
                fnSetMsg('ยังไม่ได้ระบุรหัส');
                if (!code) {
                    fnSetMsg('ยังไม่ได้ระบุรหัส');
                } else {
                    fnSetMsg('ประมวลผล');
                    applyUserToGroupAsync(curUserId, code)
                        .then((response) => {
                            if (response.message) {
                                fnSetMsg(response.message);
                            } else {
                                SetIsOpen(false);
                                dispatch(setUserGroups(response));
                                // #DEFINE DEBUG WAIT NEW VERSION dispatch(getChatRoomLists());
                                // console.log(response);
                            }
                        })
                        .catch(error => {
                            fnSetMsg((error as Error).message);
                        });

                    // dispatch(applyUserToGroup(-1, -1, ));

                }

            }
        } catch (e) {
            alert((e as Error).message);
        }
        return false;
    }

    useEffect(() => {
        // console.log('UserGroupModelOpen = ' + isOpen);
    }, [isOpen]);

    //const modalTitle = curUserType == UserTypes.Employee ? 'ใส่รหัสห้องแชท' : 'ใส่รหัสห้องแชท';
    const modalTitle = "ใส่รหัสห้องแชท ที่จะเข้าร่วม";

    // const ModalInputInviteCode = () => {
    const ModalInputInviteCode = React.memo(() => {
        return (
            <Modal isOpen={isOpen} toggle={onClose} tabIndex={-1} centered scrollable >
                <ModalHeader className="bg-primary" toggle={onClose}>
                    <div className="modal-title-custom text-white font-size-16 ">
                        {modalTitle}
                    </div>
                </ModalHeader>
                <ModalBody className="p-4">
                    <div className="mb-3">
                        <div ref={txtError} className={"alert alert-" + errClass + " text-center"} style={{ display: "none" }}></div>
                    </div>
                    <div className="mb-3">
                        <div className="input-group mb-3">
                            <input ref={txtCodeRef} type="text" className="form-control invite-code" placeholder="ป้อนรหัสที่นี่" onKeyDown={(event) => onKeyDown(event)} />
                            <div className="input-group-append">
                                {/* <a href="#" onClick={(event) => onConfirmCode(event)}>hello</a> */}
                                <button className="btn btn-outline-secondary" type="button" onClick={(event) => onConfirmCode(event)}>ยืนยัน</button>
                            </div>
                        </div>
                    </div>
                    {/* <div className="mb-3">
                            <div className="text-center">
                                นำรหัสนี้ไปกรอกตอนสมัคร เพื่อเข้าร่วมกลุ่ม
                            </div>
                        </div> */}
                </ModalBody>
                <ModalFooter>
                    <Button type="button" color="link" className="btn" onClick={onClose} >
                        ปิด
                    </Button>
                    {/* <Button
                    type="button"
                    color="primary"
                    // disabled={!valid}
                    onClick={() => onInvite(data)}
                >
                    Invite
                </Button> */}
                </ModalFooter>
            </Modal>
        );
    });

    return (
        <>
            <ModalInputInviteCode />
            <div>
                <div className="d-flex">
                    <div className="flex-grow-1">
                        {/* <h5 className="text-muted text-uppercase">กลุ่มที่อยู่</h5> */}
                        <p className="mb-1">กลุ่มที่อยู่</p>
                    </div>
                    <div className="flex-shrink-0">
                        <Link to="#" className="font-size-12 d-block mb-2" onClick={onAddGroup}>
                            เพิ่มกลุ่ม
                        </Link>
                    </div>
                </div>
                <div>
                    {groups ? (
                        <ul className="list-unstyled chat-list mx-n4">
                            {(groups || []).map((item: any, key: number) => {

                                return (
                                    <li key={key}>
                                        <Link to="#">
                                            <div className="d-flex align-items-center">
                                                {/* <div className="flex-shrink-0 avatar-xs me-2">
                                                    {logo(item)}
                                                </div> */}

                                                <UserAvatar
                                                    profileImage={item.pictureUrl}
                                                    bgColor={item.bgColor}
                                                    foreColor={item.foreColor}
                                                    abbrName={item.abbrName}
                                                />

                                                <div className="flex-grow-1 overflow-hidden"><p className="text-truncate mb-0">{item.groupName}</p></div>

                                                <div className="ms-auto">
                                                    <span className="mdi mdi-close" style={{ color: "red" }} onClick={() => onRemoveGroup(item.groupId, item.memberId)}></span>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                )
                            })}
                        </ul>
                    ) : "ยังไม่มีกลุ่ม"}
                </div>
            </div>
        </>
    );
}

export default UserGroups;